import React from 'react';
import Dict from 'dict-lib';
import {saveNotes} from './SenseAction';
import {Grid, Row, InputGroup, FormControl, Button} from 'react-bootstrap';
import './../../../../_css/lexeme.css';

import stylesLexemeSenses from './../../../../_css/dictionary/lexemeParts/lexemeSenses.module.css';
import {LexemeUtilities} from "../LexemeHelper";
import ReactDom from "react-dom";
import {SCSubmitButton} from "../../../../dict-components/submitButton/SCSubmitButton";

export class SenseNotes extends React.Component {

    constructor(props) {
        super(props);

        this.langDescr = this.props.item.description[0].language;

        this.state = {
            items: this.props.item.local_senses
        };

        this._handleSenseNote = this._handleSenseNote.bind(this);
        this._saveSenseNotes = this._saveSenseNotes.bind(this);
    }

    _handleSenseNote(item, evt) {
        var items = this.state.items;
        var index = this.state.items.indexOf(item);

        if (typeof items[index].notes === 'undefined' || items[index].notes.notes_language_group.length === 0) {
            items[index].notes = {notes_language_group: []};
            items[index].notes.notes_language_group.push({language: this.langDescr, text: evt.target.value})
        } else {
            var note = this._findNoteByLang(index);
            note.text = evt.target.value;
        }

        this.setState({items});
    }

    _findNoteByLang(index) {
        return this.state.items[index].notes.notes_language_group.find((item) => {
            return item.language === this.langDescr;
        });
    }

    componentDidMount() {
        ReactDom.findDOMNode(this.entryNote).focus();
    }

    _saveSenseNotes() {
        var items = JSON.stringify(this.state.items);

        this.setState({btDisabled: true});
        saveNotes(items).then(result => {
            this.setState({btSaveState: "success", btDisabled: false}, function () {
                setTimeout(function () {
                    this.setState({btSaveState: "primary"});
                }.bind(this), 1000);
            });
        });
    }

    render() {

        return <Grid className={stylesLexemeSenses['sense-notes-container']} fluid>
            {this.state.items ? this.state.items.map((item, index) => {
                const itemNotes = this.state.items[index].notes;
                const notes = typeof itemNotes !== 'undefined' && itemNotes.notes_language_group. length > 0? this._findNoteByLang(index).text : '';

                return <Row>
                    <InputGroup className={stylesLexemeSenses['sense-notes__input-group']}>
                        <InputGroup.Addon>{item.language}</InputGroup.Addon>
                        <FormControl type="text" placeholder={Dict.t('FORM') + "..."}
                                     ref={(input) => {
                                         this.entryNote = input;
                                     }}
                                     value={notes}
                                     onChange={(evt) => this._handleSenseNote(item, evt)}
                                     onKeyUp={(evt) => {
                                         LexemeUtilities.handleKeyUp(evt, () => {
                                             this._saveSenseNotes();
                                         })
                                     }}
                        />
                    </InputGroup>
                </Row>
            }) : ""}
            <Row className={stylesLexemeSenses['sense-notes__row-bt']}>
                <SCSubmitButton onClick={this._saveSenseNotes} text={Dict.t('SAVE')}/>
            </Row>
        </Grid>;
    }


}
